/// <amd-module name="VSS/Redux/Deprecated/HubViewState/HubViewStateReducer" />
import { default as produce } from "immer";
import { IHubViewState } from "VSS/Redux/Deprecated/HubViewState/HubViewStateContracts";
import { HubViewStateActions, HubViewStateActionTypes } from "VSS/Redux/Deprecated/HubViewState/HubViewStateActions";

export function hubViewStateReducer(state: IHubViewState, action: HubViewStateActions): IHubViewState {
    state = state || getDefaultState();
    return produce(state, draft => {
        switch (action.type) {
            case HubViewStateActionTypes.Initialize: {
                const { pivotKey, filterState, viewOptions } = action.payload;
                draft.currentPivot = pivotKey;
                draft.currentFilterState = filterState;
                draft.currentViewOptions = viewOptions;
                break;
            }
            case HubViewStateActionTypes.CurrentPivotChanged: {
                draft.currentPivot = action.payload;
                break;
            }

            case HubViewStateActionTypes.FilterStateChanged: {
                draft.currentFilterState = { ...state.currentFilterState, ...action.payload };
                break;
            }

            case HubViewStateActionTypes.ViewOptionsChanged: {
                draft.currentViewOptions = { ...state.currentViewOptions, ...action.payload };
                break;
            }
        }
    });
}

function getDefaultState(): IHubViewState {
    return {
        currentFilterState: {},
        currentPivot: "",
        currentViewOptions: {}
    };
}
